import { Component, input, Input } from '@angular/core';
import { LassoSelectionDirective } from '../../../../../directives/lasso-selection.directive';
import { TableData, TableOverlayLine } from '../../../../../table-overlay/table-overlay';
import { Dimension2d, Interval, Vector2, WordRect } from '@ps-gui/claims-terminal-shared';
import { Keys } from '@ps-gui/shared-core';

@Component({
  selector: 'ct-extraction-table-overlay-preview-lines',
  template: `
    @if (this.shouldDisplayHorizontalPreviewLine) {
      <div
        class="border-primary pointer-events-none absolute w-full border"
        [style.top.px]="mouseY * dimension().height"
        [style.left.px]="tableRect.x[0] * dimension().width"
        [style.width.px]="(tableRect.x[1] - tableRect.x[0]) * dimension().width"></div>
    }

    @if (this.shouldDisplayVerticalPreviewLine) {
      <div
        class="pointer-events-none absolute border border-[#72c8e5]"
        [style.left.px]="mouseX * dimension().width"
        [style.top.px]="tableRect.y[0] * dimension().height"
        [style.height.px]="(tableRect.y[1] - tableRect.y[0]) * dimension().height"></div>
    }
  `,
})
export class TableOverlayPreviewLinesComponent {
  @Input({ required: true }) tableData!: TableData;
  @Input({ required: true }) arePreviewLinesEnabled!: boolean;
  readonly lassoSelection = input.required<LassoSelectionDirective>();
  @Input({ required: true }) tableRect!: WordRect;
  @Input({ required: true }) currentDragInfos!: {
    line: TableOverlayLine;
    offsetRestriction: Interval;
  }[];
  readonly dimension = input.required<Dimension2d>();

  protected get mouseX(): number {
    return this.lassoSelection().currentMousePosition()[0];
  }

  protected get mouseY(): number {
    return this.lassoSelection().currentMousePosition()[1];
  }

  protected isMouseInTableRect(): boolean {
    const mousePosition = this.lassoSelection().currentMousePosition();
    return this.isPointInRect(mousePosition, this.tableRect);
  }

  protected get shouldDisplayHorizontalPreviewLine(): boolean {
    return (
      this.shouldDisplayPreviewLines &&
      (!Keys.Control.isPressed() || Keys.Alt.isPressed()) &&
      this.isMouseInTableRect()
    );
  }

  protected get shouldDisplayVerticalPreviewLine(): boolean {
    return (
      this.shouldDisplayPreviewLines &&
      (Keys.Control.isPressed() || Keys.Alt.isPressed()) &&
      this.isMouseInTableRect()
    );
  }

  protected isPointInRect(point: Vector2, rect: WordRect): boolean {
    return this.isInInterval(point[0], rect.x) && this.isInInterval(point[1], rect.y);
  }

  protected isInInterval(value: number, interval: Interval) {
    return value >= interval[0] && value <= interval[1];
  }

  private get shouldDisplayPreviewLines(): boolean {
    return (
      this.arePreviewLinesEnabled &&
      this.currentDragInfos.length === 0 &&
      !this.tableData.layoutDefined()
    );
  }
}
